
export default {
  altitudePreview: {
    expandAltitudeChart: 'Expand chart',
    altitude: 'Altitude'
  }
}
